export default {
  methods: {
    validateValue (rules, value) {
      if (typeof rules === 'function') {
        return rules.apply(this, [value])
      }
      const errors = []
      // eslint-disable-next-line no-unused-vars
      for (const method in rules) {
        const params = rules[method]
        let valid
        if (Array.isArray(params)) {
          valid = this.validate[method](value, ...params)
        } else {
          valid = this.validate[method](value, params)
        }
        if (!valid) {
          errors.push(this.friendlyError({ method: method, params: params }))
        }
      }
      if (errors.length === 0) {
        return { result: true, errors: errors }
      } else {
        return { result: false, errors: errors }
      }
    },
    validateFields () {

    },
    validateInput (input) {
      const validation = input.dataset.validate.split(/\|/)
      const validationMethod = validation.shift()
      const valid = this.validate[validationMethod](input.value, ...validation)
      return valid
    },
    friendlyError (error) {
      let message = ''
      const method = error.method
      const params = error.params
      switch (method) {
        case 'string':
          if (typeof params[1] !== 'undefined') {
            message = `Please enter between ${params[0]} and ${params[1]} characters`
          } else {
            message = `Please enter at least ${params[0]} characters`
          }
          break
        case 'required':
          message = 'Required field'
          break
        case 'regex':
          message = params[2]
          break
        default:
          message = 'Invalid field'
          break
      }
      return message
    }
  },
  computed: {
    validate () {
      return {
        required (value, message) {
          if (typeof value === 'undefined' || value === null) {
            return false
          } else if (typeof value === 'string' && value.trim() === '') {
            return false
          } else {
            return true
          }
        },
        string (str, min, max) {
          if (!str || typeof str === 'undefined') {
            if (min === 0) {
              return true
            } else {
              return false
            }
          }
          let valid = true
          if (str.length < min) {
            valid = false
          }
          if (typeof max !== 'undefined' && str.length > max) {
            valid = false
          }
          return valid
        },
        regex (str, rxMatch, rxNot, message) {
          let valid = true
          if (!str || typeof str === 'undefined') {
            if (!rxMatch) {
              valid = true
            } else {
              if (typeof rxMatch === 'string') {
                rxMatch = new RegExp(rxMatch)
              }
              if (!str.match(rxMatch)) {
                valid = false
              }
            }
            return valid
          }
          
          if (rxMatch) {
            if (typeof rxMatch === 'string') {
              rxMatch = new RegExp(rxMatch)
            }
            if (!str.match(rxMatch)) {
              valid = false
            }
          }
          if (rxNot) {
            if (typeof rxNot === 'string') {
              rxNot = new RegExp(rxNot)
            }
            if (str.match(rxNot)) {
              valid = false
            }
          }
          return valid
        }
      }
    }
  }
}
